// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BottomBalloonsSelection_wrapper__3nh4W","title":"BottomBalloonsSelection_title__l_kuu","sectionTitle":"BottomBalloonsSelection_sectionTitle__3ftJR"};